import React from 'react';

interface InitialsAvatarProps {
  name: string;
  size?: number;
  bgColor?: string;
  textColor?: string;
  borderColor?: string;
}

const InitialsAvatar: React.FC<InitialsAvatarProps> = ({
  name,
  size = 40,
  bgColor = '#FFFFFF',
  textColor = '#007BFF',
  borderColor = '#007BFF',
}) => {
  const initials = name
    ?.split('@')[0]
    ?.split(/[.\s_-]/)
    .map((part) => part[0]?.toUpperCase())
    .join('')
    .slice(0, 2);

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: bgColor,
        color: textColor,
        fontWeight: 'bold',
        fontSize: size * 0.4,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: `1px solid ${borderColor}`,
        userSelect: 'none',
      }}
    >
      {initials}
    </div>
  );
};

export default InitialsAvatar;
